import React, { useState } from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

// Components
import DashboardNavigation from "./DashboardMenu";
import TitleBarNav from "./Title";


/**
 * Main dashboard layout component that wraps dashboard pages
 * Handles sidebar states and theme application
 */
const DashboardLayout = ({ children }) => {
  // Local state for mobile menu toggle
  const [menuOpen, setMenuOpen] = useState(false);
  
  // Get theme and sidebar status from Redux store
  const darktheme = useSelector((state) => state.features.settings.darktheme);
  const barStatus = useSelector((state) => state.auth.leftSideBar);
  
  // Current route information
  const router = useLocation();

  return (
    <div
      className={`h-screen relative flex justify-content items-center ${
        darktheme ? "bg-kdark3 text-white" : "bg-[#fafafa] text-[#27272E]"
      }`}
    >
      {/* Main navigation sidebar - hidden on mobile */}
      <aside
        className={`hidden h-screen ${
          barStatus?.showSearchBar ? "w-[80px]" : "min-w-[272px]"
        } overflow-y-auto lg:block border-r z-[99]`}
      >
        <DashboardNavigation pathname={router.pathname} />
      </aside>

    

      {/* Main content area */}
      <div className="h-screen w-full mx-auto overflow-y-auto overflow-x-hidden">
        {/* Fixed top navigation bar */}
        <div className="sticky top-0 z-[20]">
          <TitleBarNav
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            pathname={router?.pathname}
          />
        </div>

        {/* Page content with fade-in animation */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          {children}
        </motion.div>
      </div>
    </div>
  );
};

export default DashboardLayout;